import { Button } from '@cian/ui-kit';

interface ISubmitButtonProps {
  buttonText: string;
  handleSubmit(): void;
}

export const SubmitButton: React.FC<ISubmitButtonProps> = props => {
  const { handleSubmit, buttonText } = props;

  return (
    <Button data-testid="select_realtor_submit" theme="fill_primary" onClick={handleSubmit} size="M">
      {buttonText}
    </Button>
  );
};

SubmitButton.displayName = 'SubmitButton';
